import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import '../home/Home.css';

class InfluencerLanding extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="for-influencers-container">
        <MetaTags>
          <title>For Influencers</title>
          <meta
            name="description"
            content="Hypepilot is an open, free-to-register platform that allows influencers and companies to connect. We offer instant payouts for the work you perfor. Our platform allows you to receive offers and chat in real-time with companies, while providing you with a system to track your deals and earnings so that you never lose a single dollar ever again."
          />
          <meta
            name="keywords"
            content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
          />
        </MetaTags>
        <div className="nav-bar-holder">
          <nav className="navbar navbar-expand-sm navbar-light" />
        </div>
        <div className="container">
          <div className="text-header-container">
            <div className="header-holder">
              <h2 className="page-text-heading">Influencers</h2>
            </div>
            <p className="padded-top-paragraph">
              Hypepilot is an open, free-to-register platform that allows
              influencers and companies to connect. Receive offers from
              companies that value your content and identity. Conveniently
              manage all your deals in one place without having to check a
              calendar for deadlines. Create the content your followers love and
              get paid fast with our instant payouts.
            </p>
          </div>
        </div>
        <img className="side-page-img" src="/images/influencer-page-main.png" />
        <div
          id="features"
          className="influencer-wrapper container primary-font-color"
        >
          <div className="row">
            <div className="col-sm-6">
              <img className="influencer-icon-10" src="/images/view-list.png" />
              <h3 className="influencer-heading">
                Receive offers from companies
              </h3>
              <p className="influencer-para">
                Review and respond to the companies which value your content.
                You get the final say on everything. 
              </p>
            </div>
            <div className="col-sm-6">
              <img
                className="influencer-icon-3"
                src="/images/file-document-box.png"
              />
              <h3 className="influencer-heading">
                Overview of your deals and earnings
              </h3>
              <p className="influencer-para">
                Never lose track of a single dollar ever again. Hypepilot’s
                deals management feature allows you to keep track of earnings,
                publishing deadlines, and more.
              </p>
            </div>
          </div>
          <div className="row padded-top-row">
            <div className="col-sm-6">
              <img className="influencer-icon-5" src="/images/cash-usd.png" />
              <h3 className="influencer-heading">Receive instant payouts</h3>
              <p className="influencer-para">
                Stop waiting and start stacking paper. Eligible debit cards are
                credited immediately directly to your Paypal account.
              </p>
            </div>
            <div className="col-sm-6">
              <img className="influencer-icon-5" src="/images/forum.png" />
              <h3 className="influencer-heading">Live chat with brands</h3>
              <p className="influencer-para">
                Emails are old, slow, and boring. Hypepilot allows for real-time
                communication with the people you’re working with.
              </p>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-sm navbar-light" />
      </div>
    );
  }
}

export default InfluencerLanding;



// WEBPACK FOOTER //
// ./src/components/home/ForInfluencers.js